// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3hW1b","topBottomGutter":"Layout_topBottomGutter__36y2p"};